import React from "react";

export default function Preloader() {
  return (
    <div className="preloader">
      <div className="status">
        <div className="spinner-border avatar-sm text-primary m-2" role="status"></div>
      </div>
    </div>
  );
}
